



























import {Vue, Component} from 'vue-property-decorator'
import Footers from '@/components/Footers.vue'
import Logo from '@/components/common/Logo.vue';
import { deleteAuthInfoToLogOut } from '@/utils/authUtils';

@Component({
  components: {Footers, Logo}
})
export default class ErrorPageUnauthorized extends Vue {
  private mounted(){
    deleteAuthInfoToLogOut();
    $('body').addClass('error_page');
    $('#container').addClass('layout_error');
  }
  private beforeDestroyed() {
    $('body').removeClass('error_page');
    $('#container').removeClass('layout_error');
  }
  private back2Main() {
    // (임시-추후 복원)레거시 로그인 페이지로 이동을 위해
    this.$router.replace('/login');
    // window.location.href = '/login';
  }
}
